import RulesetsHeader from "./components/rulesets-header";
import RulesetsList from "./components/rulesets-list";
import useRulesets, { RulesetsState } from "./hooks/use-rulesets";

export default function RuleSets() {
  const rulesetsState: RulesetsState = useRulesets();

  return (
    <div className="flex-grow flex flex-col w-full">
      <RulesetsHeader state={rulesetsState} />
      <RulesetsList state={rulesetsState} />
    </div>
  );
}
